<template>
<div class="footer">
    <h3 style="color:#ffffff">Developed By <a href="https://www.linkedin.com/in/ragul-rajkumar-4b7246195/" style="text-decoration:none;color: white;">Ragul Rajkumar</a></h3>
</div>
</template>
<script>

export default {
     name: 'Footer',
}
</script>

<style>
.footer {
  width: 100%;
  background-color: #000000;  
}
</style>
